// @generated by protoc-gen-connect-es v0.10.0 with parameter "target=ts"
// @generated from file src/protos/analysis_management/analysis.teacher.apis.proto (package geneo.analysis.teacher.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { FetchHomeworkStatisticsRequest, FetchHomeworkStatisticsResponse, FetchStudentSubjectPerformanceStatsRequest, FetchStudentSubjectPerformanceStatsResponse, FetchStudentSubjectPerformanceStatsV2Request, FetchStudentSubjectPerformanceStatsV2Response, GetChapterAnalysisRequest, GetChapterAnalysisResponse, GetChapterAnalysisV2Request, GetChapterAnalysisV2Response, TeacherAnalysisClassSubjectChapterResponse, TeacherAnalysisClassSubjectChapterV2Response, TeacherAnalysisClassSubjectRequest, TeacherAnalysisClassSubjectResponse, TeacherAnalysisClassSubjectV2Request, TeacherAnalysisClassSubjectV2Response, TeacherAnalysisRequest, TeacherAnalysisResponse, TeacherAnalysisV2Request, TeacherAnalysisV2Response } from "./analysis.teacher.apis_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV1
 */
export const TeacherAnalysisAPIServiceV1 = {
  typeName: "geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV1",
  methods: {
    /**
     * @generated from rpc geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV1.getOverallAnalysis
     */
    getOverallAnalysis: {
      name: "getOverallAnalysis",
      I: TeacherAnalysisRequest,
      O: TeacherAnalysisResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV1.getClassSubjectAnalysis
     */
    getClassSubjectAnalysis: {
      name: "getClassSubjectAnalysis",
      I: TeacherAnalysisClassSubjectRequest,
      O: TeacherAnalysisClassSubjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV1.getClassSubjectChapterAnalysis
     */
    getClassSubjectChapterAnalysis: {
      name: "getClassSubjectChapterAnalysis",
      I: TeacherAnalysisClassSubjectRequest,
      O: TeacherAnalysisClassSubjectChapterResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV1.fetchStudentSubjectPerformanceStats
     */
    fetchStudentSubjectPerformanceStats: {
      name: "fetchStudentSubjectPerformanceStats",
      I: FetchStudentSubjectPerformanceStatsRequest,
      O: FetchStudentSubjectPerformanceStatsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV1.fetchHomeworkStatistics
     */
    fetchHomeworkStatistics: {
      name: "fetchHomeworkStatistics",
      I: FetchHomeworkStatisticsRequest,
      O: FetchHomeworkStatisticsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV1.getChapterAnalysis
     */
    getChapterAnalysis: {
      name: "getChapterAnalysis",
      I: GetChapterAnalysisRequest,
      O: GetChapterAnalysisResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * @generated from service geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV2
 */
export const TeacherAnalysisAPIServiceV2 = {
  typeName: "geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV2",
  methods: {
    /**
     * @generated from rpc geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV2.getOverallAnalysis
     */
    getOverallAnalysis: {
      name: "getOverallAnalysis",
      I: TeacherAnalysisV2Request,
      O: TeacherAnalysisV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV2.getClassSubjectAnalysis
     */
    getClassSubjectAnalysis: {
      name: "getClassSubjectAnalysis",
      I: TeacherAnalysisClassSubjectV2Request,
      O: TeacherAnalysisClassSubjectV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV2.getClassSubjectChapterAnalysis
     */
    getClassSubjectChapterAnalysis: {
      name: "getClassSubjectChapterAnalysis",
      I: TeacherAnalysisClassSubjectV2Request,
      O: TeacherAnalysisClassSubjectChapterV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV2.fetchStudentSubjectPerformanceStats
     */
    fetchStudentSubjectPerformanceStats: {
      name: "fetchStudentSubjectPerformanceStats",
      I: FetchStudentSubjectPerformanceStatsV2Request,
      O: FetchStudentSubjectPerformanceStatsV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.teacher.apis.TeacherAnalysisAPIServiceV2.getChapterAnalysis
     */
    getChapterAnalysis: {
      name: "getChapterAnalysis",
      I: GetChapterAnalysisV2Request,
      O: GetChapterAnalysisV2Response,
      kind: MethodKind.Unary,
    },
  }
} as const;

